import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { TabsList } from './subcomponents';
import { LEFT_ARROW_KEY, RIGHT_ARROW_KEY } from '../../../const/keyNames';
const Tabs = (props) => {
    const { defaultTab = 0, className = '', children } = props;
    const [activeTabIndex, setActiveTabIndex] = React.useState(defaultTab);
    const activeTabId = children[activeTabIndex].props.id;
    const tabsRef = useRef([]);
    const childrenSize = children.length - 1;
    const handleTabClick = (index) => {
        setActiveTabIndex(index);
    };
    const handleKeyDown = ({ key }) => {
        let newActiveIndex = activeTabIndex;
        if (key === LEFT_ARROW_KEY) {
            newActiveIndex = activeTabIndex === 0 ? childrenSize : activeTabIndex - 1;
        }
        if (key === RIGHT_ARROW_KEY) {
            newActiveIndex = childrenSize === activeTabIndex ? 0 : activeTabIndex + 1;
        }
        setActiveTabIndex(newActiveIndex);
        tabsRef.current.at(newActiveIndex).focus();
    };
    return (_jsxs(_Fragment, { children: [_jsx(TabsList, Object.assign({ className: className }, props, { role: "tablist", "aria-orientation": "horizontal", onKeyDown: handleKeyDown }, { children: children.map((element, index) => {
                    return React.cloneElement(element, {
                        index,
                        isActive: activeTabIndex === index,
                        key: `${index + 1}`,
                        handleTabClick,
                        forwardRef: (refElement) => {
                            var _a, _b;
                            if (((_a = tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) === null || _a === void 0 ? void 0 : _a.length) < children.length) {
                                (_b = tabsRef.current) === null || _b === void 0 ? void 0 : _b.push(refElement);
                            }
                        }
                    });
                }) })), _jsx("section", Object.assign({ role: "tabpanel", id: `${activeTabId}-content`, "aria-labelledby": activeTabId, tabIndex: 0 }, { children: children[activeTabIndex] && children[activeTabIndex].props.children }))] }));
};
export default Tabs;
